import { LocaleCodes } from '@mitchell/react.component.ux';
import i18next from 'i18next';
import { Language, LanguageCode, CountryCode } from '../enums';
const i18n = require('i18next'); //Initialize i18next.t function for jest unit testing
const locale = new Map([
    [Language.ENGLISH, Language.ENGLISH_US.toLowerCase()],
    [Language.SPANISH, Language.SPANISH_SPAIN.toLowerCase()],
    [Language.FRENCH, 'ca-fr']
]);
export class TranslationService {
    static translate(key, options) {
        return i18n.t(key, options) ? i18n.t(key, options).toString() : key;
    }
    static getLocaleLanguage(language) {
        const result = locale.get(language ? language : Language.ENGLISH);
        return result ? result : Language.ENGLISH_US.toLowerCase();
    }
    /**
     * This helps translate the current locale language to language code used by legacy API calls used in MCE
     */
    static getLanguageCode() {
        var _a;
        switch (((_a = i18next.language) !== null && _a !== void 0 ? _a : Language.ENGLISH).toUpperCase()) {
            case Language.FRENCH_CANADA.toUpperCase():
            case Language.FRENCH_FRANCE.toUpperCase():
            case Language.FRENCH.toUpperCase(): {
                return LanguageCode.FRENCH;
            }
            case Language.SPANISH_SPAIN.toUpperCase():
            case Language.SPANISH.toUpperCase(): {
                return LanguageCode.SPANISH;
            }
            default: {
                return LanguageCode.ENGLISH;
            }
        }
    }
    static getLanguageCountryCode() {
        var _a;
        switch (((_a = i18next.language) !== null && _a !== void 0 ? _a : Language.ENGLISH).toUpperCase()) {
            case Language.FRENCH_CANADA.toUpperCase():
            case Language.FRENCH_FRANCE.toUpperCase():
            case Language.FRENCH.toUpperCase(): {
                return CountryCode.CANADA;
            }
            case Language.SPANISH_SPAIN.toUpperCase():
            case Language.SPANISH.toUpperCase(): {
                return CountryCode.SPAIN;
            }
            default: {
                return CountryCode.UNITED_STATES;
            }
        }
    }
    static getCurrentLanguage() {
        return i18next.language;
    }
    static getCurrentSupportedLocale() {
        let currentLocale = (i18next === null || i18next === void 0 ? void 0 : i18next.language) || LocaleCodes.EN_US;
        if (i18next && i18next.options && i18next.options.whitelist) {
            const supportedLocale = i18next.options.whitelist.find((locale) => locale.toLowerCase() === currentLocale.toLowerCase());
            currentLocale = !!supportedLocale ? supportedLocale : LocaleCodes.EN_US;
        }
        return currentLocale;
    }
    static setCurrentLanguage(language) {
        i18next.changeLanguage(language);
    }
}
//# sourceMappingURL=TranslationService.js.map